import React from 'react'
import Collection from './Collection'
import { string, object, array } from 'prop-types'

const AdBanner = ({
  smallHeadingText,
  headingText,
  contentTextPt1,
  contentTextPt2,
  contentTextPt3,
  buttons,
  image,
  imageWebP,
  imageSize,
  clickActions
}) => (
  <Collection
    smallHeadingText={smallHeadingText}
    headingText={headingText}
    contentTextPt1={contentTextPt1}
    contentTextPt2={contentTextPt2}
    contentTextPt3={contentTextPt3}
    buttons={buttons}
    image={image}
    imageWebP={imageWebP}
    imageSize={imageSize}
    clickActions={clickActions}
  />
)

AdBanner.displayName = 'AdBanner'

AdBanner.defaultProps = {
  headingText: 'AdBanner Content'
}

AdBanner.propTypes = {
  smallHeadingText: string,
  headingText: string,
  contentTextPt1: string,
  contentTextPt2: string,
  contentTextPt3: string,
  buttons: array,
  image: string,
  imageWebP: string,
  imageSize: string,
  clickActions: object
}

export default AdBanner
